import type { ReactNode } from 'react';

export const symbol_timer_1: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M531.5-211.67Q520-223.33 520-240v-440H360q-16.67 0-28.33-11.74Q320-703.47 320-720.24q0-16.76 11.67-28.26Q343.33-760 360-760h180q24.75 0 42.38 17.62Q600-724.75 600-700v460q0 16.67-11.74 28.33Q576.53-200 559.76-200q-16.76 0-28.26-11.67Z"
		/>
	</svg>
);
